import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInboxEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconInboxEmpty"><Path d="M2 12.5H8.5L10 14.5H14L15.5 12.5H22M22.5 12L18.3 4.5H5.7L1.5 12V19.5H22.5V12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconInboxEmpty;
